import React from 'react';
import { SectionWrapper } from './SectionWrapper';
import { QuoteIcon } from 'lucide-react';
export function ProofSection() {
  return <SectionWrapper className="bg-brand-amber/10" data-id="element-144">
      <div className="max-w-4xl mx-auto text-center" data-id="element-145">
        <QuoteIcon className="w-16 h-16 text-brand-amber mx-auto mb-8 opacity-50" data-id="element-146" />

        <h2 className="font-serif text-3xl md:text-5xl font-bold text-brand-brown mb-8 leading-tight" data-id="element-147">
          En solo 7 días, la mayoría de las mujeres reportan un descenso del{' '}
          <span className="text-brand-terracotta" data-id="element-148">60%</span> en la intensidad de
          los sofocos.
        </h2>

        <p className="font-sans text-xl md:text-2xl text-brand-brown/80 italic leading-relaxed max-w-3xl mx-auto" data-id="element-149">
          "Y por primera vez en meses, logran dormir hasta que suena la alarma,
          despertando con la mente clara y sin esa sensación de 'resaca'
          matutina."
        </p>
      </div>
    </SectionWrapper>;
}